import { SectionCard } from '@/components/common/SectionCard';
import { SectionCta } from '@/features/public-pages';
import { OFFER_CTA } from '@/lib/constants/issue-report';
import { ROUTES } from '@/lib/constants/routes';
import { LEGAL_COMMAND_CENTER_BUY as COPY } from '../constants';

/**
 * The Legal Command Center's top for someone with no startup (an individual,
 * an investor, a partner): the public page's Issue Report CTA, which keeps the
 * purchase intent and runs the existing journey, creating a startup first
 * (MYN-331, FR-299, A-329).
 */
export function IssueReportBuyPrompt() {
  return (
    <SectionCard>
      <div className="flex max-w-2xl flex-col gap-2">
        <p className="text-green text-xs font-semibold tracking-wide uppercase">{COPY.EYEBROW}</p>
        <h2 className="text-h3 text-navy">{COPY.TITLE}</h2>
        <p className="text-text-secondary text-sm">{COPY.BODY}</p>
        <div className="mt-4">
          <SectionCta
            label={COPY.CTA}
            url={ROUTES.ISSUE_REPORT_START}
            offerCta={OFFER_CTA.ISSUE_REPORT}
          />
        </div>
      </div>
    </SectionCard>
  );
}
